import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography } from '@mui/material';
import { FlexPaper } from '@verifime/components';
import tokens from '@verifime/design-tokens';

export const IdScanComplete = ({ dataTestId }: Readonly<{ dataTestId?: string }>) => {
  return (
    <FlexPaper
      sx={{
        borderRadius: tokens.borderRadiusSm,
        padding: tokens.spacingSm,
        gap: tokens.spacingBase,
      }}
      data-component="IdScanComplete"
      data-testid={dataTestId}
    >
      <Stack direction="row" gap={tokens.spacingSm}>
        <CheckCircleIcon color="success" aria-label="success" />
        <Typography variant="h5">ID scan complete</Typography>
      </Stack>
      <Typography
        variant="body1"
        sx={{ fontWeight: tokens.fontWeightSemibold, fontSize: tokens.fontSizeBase }}
      >
        Please check your information
      </Typography>
      {/* TODO: Change to tokens once we have a design token for this */}
      <Typography variant="body1" sx={{ lineHeight: '150%', letterSpacing: '0.15px' }}>
        Check that the details below are exactly as they appear on your ID. If something doesn’t
        match, reupload your ID or update the information manually, then click &apos;Continue&apos;.
      </Typography>
    </FlexPaper>
  );
};
